import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService  {

  private path = environment.apiURL + 'access';       // Gateway route (forgot/reset/password)
  private bffAuthPath = environment.apiURLAuth;         // BFF controller (login/logout)

  constructor(private http: HttpClient) { }

  public login(email: string,
               password: string): Observable<any>{

    return this.http
               .post<any>(this.bffAuthPath,
                          {username: email,
                           password: password});
  }

  public password(email: string,
                  password: string): Observable<void>{

    return this.http
               .patch<void>(this.path + '/password',
                            {username: email,
                             password});
  }

  public forgot(email: string): Observable<void>{
    const params = new HttpParams().set('email', email);

    return this.http
               .put<void>(this.path + '/forgot',
                            null,
                            {params: params});
  }

  public reset(token: string,
               password: string): Observable<void>{

    return this.http
               .patch<void>(this.path + '/reset',
                            {token: token,
                             newPassword: password});
  }

  public logout(): Observable<void>{
    return this.http
               .delete<void>(this.bffAuthPath);
  }

  /**
   * Record the selected partner in the BFF session (Tonic staff).
   *
   * The BFF injects the Partner header on every proxied request from its
   * stored session — the pre-BFF interceptor read it from local state
   * instead, so without this call a staff user's selection never reaches
   * portal-api. portal-api remains the authority on who may act as which
   * partner; this only records the choice.
   */
  public switchPartner(partnerId: number): Observable<{partnerId: number}>{
    return this.http
               .patch<{partnerId: number}>(this.bffAuthPath + '/switch/' + partnerId,
                                           null);
  }
}
